import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setPostAirUpdateBalance = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_AIR_BALANCE_USER
            });
            dispatch(Action.SetGetUserById(params.user_id));
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostAirUpdateBalance as SetPostAirUpdateBalance
}